export default "__VITE_ASSET__BYQzQqKS__"